import { useEffect, useState } from 'react';
import { auditKindLabel, auditOutcomeLabel, auditOutcomeCssClass } from '../audit-kinds';
import { kfClient, AuditEntry } from '../kf-client';

export function AuditLog() {
  const [entries, setEntries] = useState<AuditEntry[] | 'loading' | { error: string }>('loading');

  useEffect(() => {
    let cancelled = false;
    kfClient.auditList(100)
      .then((j) => {
        if (cancelled) return;
        setEntries(j.entries ?? []);
      })
      .catch((e: Error) => {
        if (cancelled) return;
        setEntries({ error: e.message });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="view audit-log">
      <h2>Audit Log</h2>
      <p className="muted">Recent daemon actions (last 100). Newest first.</p>
      {entries === 'loading' && <p>Loading…</p>}
      {typeof entries === 'object' && 'error' in entries && (
        <p className="err">Audit unreachable: {entries.error}</p>
      )}
      {Array.isArray(entries) && entries.length === 0 && <p className="muted">No entries.</p>}
      {Array.isArray(entries) && entries.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Kind</th>
              <th>Outcome</th>
              <th>Tenant</th>
              <th>Actor</th>
              <th>Target</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e, i) => (
              <tr key={i}>
                <td>{new Date(e.ts).toISOString()}</td>
                <td><code>{auditKindLabel(e.kind)}</code></td>
                <td className={auditOutcomeCssClass(e.outcome)}>{auditOutcomeLabel(e.outcome)}</td>
                <td className="muted">{e.tenant}</td>
                <td className="muted">{e.actor}</td>
                <td className="muted">{e.target === '0:0' ? '—' : e.target}</td>
                <td className="muted">{e.detail_len > 0 ? `${e.detail_len} B` : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
